/**
 * The content service used to retrieve content.
 */
export enum CMSService {
  /** This service is builder.io {@link BuilderService}. */
  Builder = 'builder'
}
